// extracted by mini-css-extract-plugin
module.exports = {"card":"AnnoucementCard_card__3ry24"};